module.exports = __webpack_public_path__ + "static/media/p7.0cdf0cb7.pdf";